import { render, staticRenderFns } from "./OrdersSupplier.vue?vue&type=template&id=f0343636&"
import script from "./OrdersSupplier.vue?vue&type=script&lang=js&"
export * from "./OrdersSupplier.vue?vue&type=script&lang=js&"
import style0 from "./OrdersSupplier.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports